export default function $$(selector: string, fn: (value: Element) => any) {
    return [].slice.call(document.querySelectorAll(selector)).map(fn);
}